import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { PlayerKind } from '@ppwr/poker'

import { useStore } from '../../models'
import { ThreeCardPlayer } from './ThreeCardPlayer'

export const ThreeCardBotPlayers = observer(() => {
  const {
    game: { players }
  } = useStore()

  const botPlayers = players.filter((p) => p.kind === PlayerKind.BOT)
  const botPlayersReady = botPlayers.length === 2

  return (
    <View style={styles.container}>
      <ThreeCardPlayer player={botPlayersReady ? botPlayers[0] : undefined} isBot />
      <ThreeCardPlayer player={botPlayersReady ? botPlayers[1] : undefined} isBot right />
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    gap: 120,
    width: '100%',
    top: 25
  }
})
